var _path, _path2, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.32597 5.65014V6.72708C9.55149 6.38355 9.86235 6.10446 10.2281 5.91712C10.5939 5.72979 11.002 5.64064 11.4126 5.65839C13.6052 5.65839 14.0792 7.02916 14.0792 8.81242V12.4431H12.0485V9.22429C12.0485 8.45641 11.8936 7.46894 10.698 7.46894C9.53856 7.46894 9.34056 8.30473 9.34056 9.16717V12.4431H7.31614V5.65014H9.32597ZM5.95616 3.94302C5.95591 4.1442 5.89628 4.34082 5.78474 4.50824C5.6732 4.67566 5.51471 4.80643 5.32916 4.88416C5.14368 4.96125 4.93945 4.98142 4.74248 4.94209C4.5455 4.90276 4.36468 4.80572 4.22302 4.66331C4.0811 4.52081 3.98448 4.33953 3.94531 4.14227C3.90614 3.945 3.92617 3.74056 4.00288 3.55465C4.07959 3.36874 4.20956 3.20966 4.37644 3.09742C4.54332 2.98518 4.73966 2.92478 4.94077 2.92383C5.07444 2.92383 5.20679 2.95022 5.33023 3.00148C5.45367 3.05275 5.56577 3.12788 5.66011 3.22257C5.75445 3.31726 5.82916 3.42965 5.87996 3.55328C5.93077 3.67691 5.95666 3.80936 5.95616 3.94302Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9546 5.65857H3.92383V12.4432H5.9546V5.65857Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 16,
    height: 16,
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.0ab0745245e18f7e1ddf16591fa8f635.svg";
export { ForwardRef as ReactComponent };